import { API } from "aws-amplify"
import api, { apiName } from "./constants"

export async function getWelcomeMessage() {
    try {
        return await API.get(apiName, `${api.welcome}/`, {})
    } catch (error) {
        console.error(error)
    }
}
